import { render, staticRenderFns } from "./TabelaCobrancas.vue?vue&type=template&id=71a17dbc&"
import script from "./TabelaCobrancas.vue?vue&type=script&lang=ts&"
export * from "./TabelaCobrancas.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports